
export enum CheckStatus {
    Idle,
    Checking,
    Error,
    NoError
}
